import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Button from 'housecall-ui/dist/DesignSystem/Inputs/Buttons/Button';

import { track } from 'components/Services/Analytics/AnalyticsService';

import { getCanUseApp } from '../../../../Resources/Organization/Apps/AppsData';
import { API_KEY_MANAGEMENT } from '../AppsData';
import { openPaywall } from '../Redux/Actions';

const ApiKeyManagementUpgradeButtons = () => {
  const canUseApp = useSelector(getCanUseApp(API_KEY_MANAGEMENT));
  const dispatch = useDispatch();
  const handleUpgrade = () => dispatch(openPaywall());
  const handleTellMeMore = () => {
    dispatch(
      track('Click', {
        button_name: 'tell me more',
        app_name: 'api_keys',
        pathname: '/pro/apps/details/api_keys',
      })
    );

    Intercom('showNewMessage', 'Can you tell me more about API keys?');
  };

  if (canUseApp) return null;

  return (
    <>
      <Button color="primary" variant="contained" onClick={handleUpgrade}>
        Upgrade
      </Button>{' '}
      <Button color="primary" variant="outlined" onClick={handleTellMeMore}>
        Tell me more
      </Button>
    </>
  );
};

export default ApiKeyManagementUpgradeButtons;
